"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Debug = /** @class */ (function () {
    function Debug() {
    }
    /**
     * Enable logging to help debug if you run into an issue setting up OneSignal.
     * @param  {LogLevel} nsLogLevel - Sets the logging level to print to the Android LogCat log or Xcode log.
     * @returns void
     */
    Debug.prototype.setLogLevel = function (nsLogLevel) {
        window.cordova.exec(function () { }, function () { }, "OneSignalPush", "setLogLevel", [nsLogLevel]);
    };
    ;
    /**
     * Enable logging to help debug if you run into an issue setting up OneSignal.
     * @param  {LogLevel} visualLogLevel - Sets the logging level to show as alert dialogs.
     * @returns void
     */
    Debug.prototype.setAlertLevel = function (visualLogLevel) {
        window.cordova.exec(function () { }, function () { }, "OneSignalPush", "setAlertLevel", [visualLogLevel]);
    };
    return Debug;
}());
exports.default = Debug;
